// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gveNQ1WpljpTF3NCdRjP {
  height: 100%;
  width: 100%;
  background-image: url("https://i.imgur.com/GZAmRtb.jpeg");
  background-size: cover;
}`, "",{"version":3,"sources":["webpack://./src/pages/IndexPage/IndexPage.module.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;EACA,yDAAA;EACA,sBAAA;AACJ","sourcesContent":[".IndexPage {\n    height: 100%;\n    width: 100%;\n    background-image: url('https://i.imgur.com/GZAmRtb.jpeg');\n    background-size: cover;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"IndexPage": `gveNQ1WpljpTF3NCdRjP`
};
export default ___CSS_LOADER_EXPORT___;
